<label class="fw-bold form-label">{{localize(langSection.LocationUserPage, langText.SearchUsers)}}</label>
<div class="input-group-text">
    <input class="form-control rounded-0 border-dark" [(ngModel)]="userSearchString"
      (input)="searchForUser()" />
    <button aria-label="Search Locations" class="btn border-dark rounded-0 bg-green" type="button"
      (click)="clearUserSearch()"><span class="{{iconClass}}"></span></button>
  </div>